import { useEffect, useState } from "react";
import Button from "../../button/button";
import logoMobile from "../../../assets/images/logo-planejadora-vertical.svg";
import logoDesktop from "../../../assets/images/logo-planejadora.svg";
import "./index.scss";

const ModalResult = ({ show, callBackClose, title, enterprise, children }) => {
  const [isOpen, setIsOpen] = useState(show);


  const modalResultClose = () => {
    setIsOpen(false);
    if (callBackClose) callBackClose();
  };
  useEffect(() => {
    setIsOpen(show);
  }, [show]);

  return (
    isOpen && (
      <div className="wrapper-modal-result">
        <div onClick={() => modalResultClose()} className="close-page"></div>
        <div className="modal-result">
          <div className="modal-result__header-modal">
            <div className="wrapper-titulo">
              <figure className="wrapper-logo">
                <img
                  src={logoDesktop}
                  alt="logo planeladora de Sebrae"
                  className="desktop"
                />
                {/* <img
                  src={logoMobile}
                  alt="logo planeladora de Sebrae"
                  className="logo mobile"
                /> */}
              </figure>
              <p className="titulo">{title}</p>
              {enterprise ? (<p className="empresa">{enterprise}</p>) : ""}
            </div>
            <button className="btn-back" onClick={() => modalResultClose()}>
                  Voltar
            </button>
          </div>
          <div className="modal-result__result-body">{children}</div>
        </div>
      </div>
    )
  );
};

export default ModalResult;
